import * as Yup from "yup";
import { toInternationalFormat } from "../../../../utils";

export const createCampaignObject = {
  brandID: "",
  audienceID: "",
  campaignID: "",
  startTime: "",
  previewImage: "",
  isEditable: true,
  campaignStatus: "",
  isBroadcast: false,
  audienceSize: {},
  permissionSettings: {},
  IsManualCampaignLive: false,

  brandDetails: {
    brandName: "",
    brandLogo: "",
  },

  campaign_name: {
    value: "",
  },

  campaign_type: {
    value: "",
  },

  about: {
    value: "",
  },

  destination_url: {
    value: "",
  },

  start_duration: {
    value: null,
  },

  end_duration: {
    value: null,
  },

  volume: {
    value: "",
  },

  budget: {
    value: {
      min: "",
      max: "",
    },
  },

  monthly_active_user: {
    value: "",
  },

  conversion_type: {
    value: "CPM",
  },

  payout_percentage: {
    value: "",
  },

  payout_terms: {
    value: "",
  },

  trial_period: {
    value: "",
  },

  category: {
    value: [],
  },

  creatives: [],

  pref_campaign_channel: {
    value: [],
  },

  whatsapp_template: {
    value: "",
  },

  whatsapp_agent: {
    value: "",
  },

  agentId: {
    value: [],
  },

  meta_delivery_type: {
    value: "MANUAL",
  },

  dv_delivery_type: {
    value: "MANUAL",
  },

  query_type: "or",
};

export function objectFromFormData(formData, activeBrand, initialValues) {
  let sDate = new Date(formData.start_duration.value);
  let eDate = new Date(formData.end_duration.value);

  let prefCampaignChannel = formData.pref_campaign_channel?.value?.filter(
    (item) => item !== null && item !== undefined
  );

  const hasChanged = (key) => {
    if (initialValues === undefined) return true; // no initial = new form
    return JSON.stringify(formData[key]) !== JSON.stringify(initialValues[key]);
  };

  const hasPlatformFieldChanges =
    (!!formData.meta_agent_id && hasChanged("meta_agent_id")) ||
    (!!formData.dv_partner_id && hasChanged("dv_partner_id")) ||
    (!!formData.dv_advertiser_id && hasChanged("dv_advertiser_id")) ||
    (!!formData.dv_advertiser_name && hasChanged("dv_advertiser_name")) ||
    (!!formData.ad_manager_id && hasChanged("ad_manager_id")) ||
    (!!formData.google_agent_id && hasChanged("google_agent_id"));

  let fields = [
    {
      campaign_name: formData.campaign_name,
    },

    {
      campaign_type: formData.campaign_type,
    },

    {
      about: formData.about,
    },

    {
      destination_url: formData.destination_url,
    },

    {
      start_duration: {
        value: sDate.toISOString(),
      },
    },

    {
      end_duration: { value: eDate.toISOString() },
    },

    {
      min_budget: {
        value: parseInt(formData.budget.value.min),
      },
    },

    {
      max_budget: {
        value: parseInt(formData.budget.value.max),
      },
    },

    {
      conversion_type: formData.conversion_type,
    },

    {
      pref_campaign_channel: { value: prefCampaignChannel },
    },
  ];

  if (formData.additional_audience) {
    fields = [
      ...fields,
      {
        additional_audience: formData.additional_audience,
      },
    ];
  }

  if (prefCampaignChannel.includes(3)) {
    fields = [
      ...fields,
      {
        meta_delivery_type: {
          value: "MANUAL",
        },
      },
    ];
  }

  if (prefCampaignChannel.includes(6)) {
    fields = [
      ...fields,
      {
        dv_delivery_type: {
          value: "MANUAL",
        },
      },
    ];
  }

  if (formData.meta_agent_id) {
    fields = [
      ...fields,
      {
        meta_agent_id: formData.meta_agent_id,
      },
    ];
  }

  if (formData.dv_partner_id) {
    fields = [
      ...fields,
      {
        dv_partner_id: formData.dv_partner_id,
      },
    ];
  }

  if (formData.dv_advertiser_id) {
    fields = [
      ...fields,
      {
        dv_advertiser_id: formData.dv_advertiser_id,
      },
    ];
  }

  if (formData.dv_advertiser_name) {
    fields = [
      ...fields,
      {
        dv_advertiser_name: formData.dv_advertiser_name,
      },
    ];
  }

  if (formData.ad_manager_id) {
    fields = [
      ...fields,
      {
        ad_manager_id: formData.ad_manager_id,
      },
    ];
  }

  if (formData.google_agent_id) {
    fields = [
      ...fields,
      {
        google_agent_id: formData.google_agent_id,
      },
    ];
  }

  return {
    brand_id: parseInt(activeBrand.ID),
    ...(!formData.campaignProcessing && {
      audience_id: formData.audienceID,
    }),
    ...(formData.campaignProcessing && {
      audience_meta: formData.audienceMeta,
      audience_id: formData.audiences[0],
    }),
    query_type: formData.query_type,
    ...(formData.campaignID &&
      hasPlatformFieldChanges && {
        update_data: true,
      }),
    preview_image:
      formData.previewImage ||
      "https://adn-media.s3.ap-south-1.amazonaws.com/company_document/1765280924610_image.png",
    fields: fields,
  };
}

export function creative(formData, campaignID) {
  return {
    creative:
      formData.sourceType === "link" ? formData.fileUrl : formData.creative,
    campaign_id: campaignID,
    adtype_id: formData.adSize,
    format: formData.format,
    link: formData.fileUrl,
    source_type: formData.sourceType,
    creative_name: formData.friendlyName,
    ...Boolean(formData.format === "ad-tag" && { ad_tag: formData.adTag }),
  };
}

export function objectFromResponse(response, audiences) {
  let data = {};
  let creativesData = [];
  let selectedAudiences = [];
  let list = [];
  for (let aud in response.audience_meta) {
    selectedAudiences.push(
      ...audiences
        .filter((item) => item.audience_id === parseInt(aud))
        .map((item) => ({
          audience_id: item.audience_id,
          audience_group: item.audience_group,
        }))
    );

    list.push(parseInt(aud));
  }

  for (let key of response.campaignData) {
    if (Object.keys(key)[0] === "category") {
      data[Object.keys(key)[0]] = {
        value: Object.values(key)[0] || [],
      };
    }

    if (
      Object.keys(key)[0] === "monthly_active_user" ||
      Object.keys(key)[0] === "volume"
    ) {
      data[Object.keys(key)[0]] = {
        value: Object.values(key)[0] || "",
      };
    } else if (Object.keys(key)[0] === "min_budget") {
      data["budget"] = {
        value: {
          min: Object.values(key)[0] || "",
        },
      };
    } else if (Object.keys(key)[0] === "max_budget") {
      data["budget"] = {
        value: {
          min: data.budget.value.min,
          max: Object.values(key)[0] || "",
        },
      };
    } else {
      data[Object.keys(key)[0]] = {
        value: Object.values(key)[0] || "",
      };
    }
  }

  for (let create of response.creatives) {
    creativesData.push({
      creativeID: create.creative_id,
      format: create.format,
      creative: create.creative,
      friendlyName: create.creative_name,
      adSize: create.adtype_id,
      adTag: create.ad_tag || "",
      sourceType: create.source_type,
      fileUrl: create.creative,
    });
  }
  return {
    ...data,
    query_type: response.query_type,
    permissionSettings: {
      ...response.admin_settings,
      consumer_audience_view: true,
    },
    audiences: list,
    campaignProcessing: response.audience_meta
      ? Object.entries(response.audience_meta)?.length > 0
      : false,
    audienceMeta: response.audience_meta,
    displayStatus: response.display_status,
    audienceSize: response.audienceSize,
    selectedAudiences: selectedAudiences,
    creatives: creativesData,
    brandID: response.brand_id,
    fileName: response.fileName,
    adminCampaignStatus: response.admin_campaign_status,
    campaignStatus: response.campaignStatus,
    campaignID: response.campaign_id,
    isEditable: response.is_editable,
    previewImage: response.preview_image,
    audienceID: response.audience.audience_id,
    campaignAdminStatus: response.admin_campaign_status,
    campaignLaunched: response.campaign_launched,
    csvUpload: response?.csv_upload,
    isBroadcast: response.isBroadcast,
    creditDetails: response.credit_details,
    status: response?.status,
    Intersection_Audience: response?.Intersection_Audience,
    cpm: response?.cpm,
    isPendingSizing: response?.isPendingSizing,
    statusApproval: response?.statusapproval,
    isCampaignLive: response?.isManualCampaignLive,
    requestStatus: response?.request_status,
    adminApprovalStatus: response?.admin_approval_status,
    isPublished: response.is_published,
  };
}

export function getAllCampaigns(response, activeBrand) {
  let allCampaigns = [];
  for (let key of response.data.campaignData) {
    let data = {};
    for (let fields of key.fields) {
      if (
        Object.keys(fields)[0] === "budget_min" ||
        Object.keys(fields)[0] === "budget_max" ||
        Object.keys(fields)[0] === "monthly_active_user" ||
        Object.keys(fields)[0] === "volume"
      ) {
        data[Object.keys(fields)[0]] = toInternationalFormat(
          Object.values(fields)[0]
        );
      } else {
        data[Object.keys(fields)[0]] = Object.values(fields)[0];
      }
    }
    allCampaigns.push({
      ...data,
      brand: {
        name: activeBrand.brandName,
        logo: activeBrand.logo,
      },
      previewImage: !!key.preview_image
        ? key.preview_image
        : "https://dc-chat-media.s3.ap-south-1.amazonaws.com/NaN_placeholder.png",
      status: key.status,
      isEditable: key.isEditable,
      audience_id: key.audience_id,
      brand_id: key.brand_id,
      campaign_id: key.campaign_id,
      audience_cpm: key.audience_cpm,
      user_Count: key?.total_user_count,
      audience_size: key?.audience_size,
      campaign_tentative_size: key?.campaign_tentative_size,
      displayStatus: key?.display_status,
    });
  }
  return allCampaigns;
}

export function getSuperAdminCampaigns(response) {
  let allCampaigns = [];
  for (let key of response.data.formattedCampaigns) {
    let data = {};
    for (let fields of key.fields) {
      if (
        Object.keys(fields)[0] === "budget_min" ||
        Object.keys(fields)[0] === "budget_max" ||
        Object.keys(fields)[0] === "monthly_active_user" ||
        Object.keys(fields)[0] === "volume"
      ) {
        data[Object.keys(fields)[0]] = toInternationalFormat(
          Object.values(fields)[0]
        );
      } else {
        data[Object.keys(fields)[0]] = Object.values(fields)[0];
      }
    }
    allCampaigns.push({
      ...data,
      brand: {
        name: key.brand.brand_name,
        logo: key.brand.brand_logo,
        agency: key?.brand?.agency_name,
      },
      previewImage: !!key.preview_image
        ? key.preview_image
        : "https://dc-chat-media.s3.ap-south-1.amazonaws.com/NaN_placeholder.png",
      status: key.status,
      audience_id: key.audience_id,
      brand_id: key.brand_id,
      campaign_id: key.campaign_id,
      user_Count: key.user_Count,
    });
  }
  return allCampaigns;
}

export const validationSchema = Yup.object().shape({
  campaign_name: Yup.object().shape({
    value: Yup.string()
      .required("Campaign Name is required")
      .min(3, "Campaign Name must be of three letters."),
  }),

  campaign_type: Yup.object().shape({
    value: Yup.string().required("Campaign Type is required"),
  }),

  campaignProcessing: Yup.boolean(),

  query_type: Yup.string().required("Query Type is required"),

  audienceID: Yup.object().when("campaignProcessing", {
    is: (value) => !value,
    then: () => Yup.string().required("Audience is required"),
    otherwise: () => Yup.string(),
  }),

  audiences: Yup.array().when("campaignProcessing", {
    is: (value) => value,
    then: () =>
      Yup.array()
        .min(1, "Atleast One value is required.")
        .required("Audience is required"),
  }),

  previewImage: Yup.string().required("Preview Image is required"),

  start_duration: Yup.object().shape({
    value: Yup.date("It should be date")
      .required("Start Date is required")
      .typeError("Start Date is required"),
  }),

  end_duration: Yup.object().shape({
    value: Yup.date()
      .test(
        "same_dates_test",
        "End date should be greater than start date.",
        function (value) {
          const start_duration = this.from[1]?.value?.start_duration.value;
          return new Date(value).getTime() > new Date(start_duration).getTime();
        }
      )
      .required("End Date is required")
      .typeError("End Date is required"),
  }),

  budget: Yup.object().shape({
    value: Yup.object().shape({
      min: Yup.number("It should be a number")
        .positive("Budget should be positive")
        .nullable()
        .min(1000, "Minimum should be 1000 or can be greater.")
        .max(10000000, "Maximum should be less than 10000000")
        // .lessThan(Yup.ref("max"), "Max Budget should be greater")
        .required("Minimum budget is required")
        .typeError("Minimum budget should be a number"),

      max: Yup.number()
        .nullable()
        .positive("Budget should be positive")
        .min(1000, "Minimum should be 1000 or can be greater.")
        .max(10000000, "Maximum should be less than 10000000")
        .moreThan(Yup.ref("min"), "Max Budget should be greater")
        .typeError("Maximum budget should be a number")
        .required("Maximum budget is required"),
    }),
  }),

  destination_url: Yup.object().shape({
    value: Yup.string()
      .matches(
        /^(http(s)?:\/\/.)[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)$/,
        "Enter correct url!"
      )
      .required("Destination url is required"),
  }),

  conversion_type: Yup.object().shape({
    value: Yup.string().required("Conversion Type is required"),
  }),

  pref_campaign_channel: Yup.object().shape({
    value: Yup.array()
      .required("Preferred Campaign Channel is required")
      .min(1, "Atleast one campaign channel should be specified"),
  }),

  dv_partner_id: Yup.object().when("pref_campaign_channel.value", {
    is: (value) => value.length > 0 && value.includes(6),
    then: () =>
      Yup.object().shape({
        value: Yup.string(),
      }),
    otherwise: () =>
      Yup.object().shape({
        value: Yup.string(),
      }),
  }),

  dv_advertiser_id: Yup.object().when("pref_campaign_channel.value", {
    is: (value) => value.length > 0 && value.includes(6),
    then: () =>
      Yup.object().shape({
        value: Yup.string(),
      }),
    otherwise: () =>
      Yup.object().shape({
        value: Yup.string(),
      }),
  }),

  dv_advertiser_name: Yup.object().when("pref_campaign_channel.value", {
    is: (value) => value.length > 0 && value.includes(6),
    then: () =>
      Yup.object().shape({
        value: Yup.string(),
      }),
    otherwise: () =>
      Yup.object().shape({
        value: Yup.string(),
      }),
  }),

  ad_manager_id: Yup.object().when("pref_campaign_channel.value", {
    is: (value) => value.length > 0 && value.includes(3),
    then: () =>
      Yup.object().shape({
        value: Yup.string(),
      }),
    otherwise: () =>
      Yup.object().shape({
        value: Yup.string(),
      }),
  }),
});

export function getAudienceDetails(audienceData) {
  let data = {};
  let additionalFields = [];

  if (!!audienceData.fields) {
    for (let key of audienceData?.fields) {
      if (
        (typeof Object.values(key)[0] === "string" &&
          !!Object.values(key)[0]) ||
        (Array.isArray(Object.values(key)[0]) &&
          Object.values(key)[0].length > 0) ||
        (!Array.isArray(Object.values(key)[0]) &&
          typeof Object.values(key)[0] === "object" &&
          Object.keys(Object.values(key)[0]).length > 0 &&
          !!Object.values(key)[0][Object.keys(Object.values(key)[0])[0]] &&
          !!Object.values(key)[0][Object.keys(Object.values(key)[0])[1]]) ||
        (typeof Object.values(key)[0] === "number" && !!Object.values(key)[0])
      ) {
        if (!key?.is_additional) {
          data[Object.keys(key)[0]] = {
            value: Object.values(key)[0],
            mandatory: Object.values(key)[1],
          };
        } else {
          additionalFields.push({
            key: Object.keys(key)[0],
            value: Object.values(key)[0],
            mandatory: Object.values(key)[1],
          });
        }
      }
    }
  } else {
    for (let key of audienceData) {
      if (
        (typeof Object.values(key)[0] === "string" &&
          !!Object.values(key)[0]) ||
        (Array.isArray(Object.values(key)[0]) &&
          Object.values(key)[0].length > 0) ||
        (!Array.isArray(Object.values(key)[0]) &&
          typeof Object.values(key)[0] === "object" &&
          Object.keys(Object.values(key)[0]).length > 0 &&
          !!Object.values(key)[0][Object.keys(Object.values(key)[0])[0]] &&
          !!Object.values(key)[0][Object.keys(Object.values(key)[0])[1]]) ||
        (typeof Object.values(key)[0] === "number" && !!Object.values(key)[0])
      ) {
        if (!key?.is_additional) {
          data[Object.keys(key)[0]] = {
            value: Object.values(key)[0],
            mandatory: Object.values(key)[1],
          };
        } else {
          additionalFields.push({
            key: Object.keys(key)[0],
            value: Object.values(key)[0],
            mandatory: Object.values(key)[1],
          });
        }
      }
    }
  }

  data = {
    ...data,
    isEditable: audienceData.is_editable,
    additionalFields: additionalFields,
    ID: audienceData.audience_id,
    brandID: audienceData.brand_id,
  };

  return data;
}

export function connectionLists(connections) {
  let connection = [];
  for (let con of connections) {
    connection.push({
      requestStatus: con.requestStatus.replace(/_/g, " "),
      logo: con.receiver_brand_info?.logo,
      monthly_active_user:
        toInternationalFormat(con.receiver_brand_info?.mau) || "",
      brandId: con.receiver_brand_info?.brandId,
      category: con.receiver_brand_info?.category || [],
      languages: con.receiver_brand_info?.languages || [],
      locations: con.receiver_brand_info?.location || [],
      name: con.receiver_brand_info?.brand_name || "",
      usersCount: con?.users_count || 0,
      senderUserId: con.sender_userId,
      senderBrandId: con.sender_brandId,
      senderCampaignId: con.sender_campaignId,
      receiverUserId: con.receiver_userId,
      receiverBrandId: con.receiver_brandId,
    });
  }
  return connection;
}

export const checkRequiredFields = (values) => {
  const missingFields = [];

  if (!values.campaign_name?.value) missingFields.push("Campaign Name");
  if (!values.campaign_type?.value) missingFields.push("Campaign Name");

  if (!values.campaignProcessing && !values.audienceID)
    missingFields.push("Audience");
  if (!values.previewImage) missingFields.push("Preview Image");

  if (!values.start_duration?.value) missingFields.push("Start Date");
  if (!values.end_duration?.value) missingFields.push("End Date");

  if (!values.budget?.value?.min) missingFields.push("Minimum Budget");
  if (!values.budget?.value?.max) missingFields.push("Maximum Budget");
  if (!values.destination_url?.value) missingFields.push("Destination URL");
  if (!values.conversion_type?.value) missingFields.push("Conversion Type");
  if (!values.pref_campaign_channel?.value)
    missingFields.push("Preferred Channels");
  return missingFields; // empty array if all present
};
